import isObject from './is-object.js';

/**
 * @func isArrayOfObjects
 * @param value - the input of the function
 * @return {boolean}
 * @desc Checks that the input is an array of objects
 *```js
 * isArrayOfObjects([1, 2]);
 * // returns false
 *
 * isArrayOfObjects([{name: 'Molly'}, {name: 'Greta'}]);
 * //returns true
 *```
 * @memberof module:TypeCheck
 * @instance
 */
function isArrayOfObjects(value) {
    if (Array.isArray(value) && value.every(item => isObject(item)))
        return true;
    return false;
}

export { isArrayOfObjects as default };
